export const AUTOS_SELL_PAGE_NAME = 'OLX_AUTOS_SELL';
